import { HelpArticleItems } from "./help-article-item";
import { HelpContainer } from "../help-shared/help-container";
import { HelpRelatedItems } from "../help-shared/related-item.jsx";
import { normalizeArticles } from "../functions/normalize-helper.jsx";
import { getThemedTiles } from "../functions/tile.jsx";
import { HelpItemType } from "../constants.js";
import { getArticleMarkdown } from "../functions/markdown.jsx";

function HelpArticle(props) {
    const getAiChatAttachment = () => {
        let attachment = props.Name + "\n\n";
        if (props.Description) {
            attachment = attachment + props.Description + "\n\n";
        }
        for (let i = 0, len = props.Items.length; i < len; i++) {
            attachment = attachment + props.Items[i].value + "\n";
        }
        return attachment;
    };

    const openAiChatSidebar = () => {
        const prompt = {
            Prompt: "I would like to ask questions about this article",
            Attachment: getAiChatAttachment()
        }
        props.OpenAiChatSidebar(prompt);
    };

    const getArticles = () => {
        if (!props.Articles || props.Articles.length === 0) return null;
        return getThemedTiles(props.Theme, normalizeArticles(props.Articles), (tile) => props.OnClick(tile.Id,  HelpItemType.Article));
    };

    const handleClickRelated = (id, type) => {
        if (typeof props.OnClickRelated === "function") {
            return props.OnClickRelated(id, type ?? HelpItemType.Article);
        }
        props.OnClick(id, type ?? HelpItemType.Article);
    };

    if (props.Visible !== undefined && props.Visible !== true) {
        return null;
    }

    return (
        <HelpContainer
            Theme={props.Theme}
            Name={props.Name}
            Description={props.Description}
            ShowAiChat={props.ShowAiChat}
            OpenAiChatSidebar={openAiChatSidebar}
            ShowCopy={props.Theme !== "web"}
            GetMarkdown={() => getArticleMarkdown(props.Name, props.Description, props.Articles, props.Items, props.RelatedArticles)}>
            {getArticles()}
            <HelpArticleItems
                Items={props.Items}
                Theme={props.Theme}
                BaseUrl={props.BaseUrl} />
            <HelpRelatedItems
                Items={normalizeArticles(props.RelatedArticles)}
                Theme={props.Theme}
                OnClick={handleClickRelated} />
        </HelpContainer>
    );
}

export { HelpArticle };